import { _ as __assign, b as __awaiter, c as __generator } from '../../chunks/bundle-j5GfJ6DZ.js';
import React__default from 'react';
import { u as useGroupChannel } from '../../chunks/bundle-BykuFiQC.js';
import { F as FileViewerView } from '../../chunks/bundle-BUqKgNmF.js';
import { u as useSendbird } from '../../chunks/bundle-DloqDvm2.js';
import '@sendbird/chat/message';
import '@sendbird/chat/groupChannel';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-S7XE7Lfi.js';
import '../../chunks/bundle-BSLHBsOu.js';
import '../../chunks/bundle-BC1GKYVu.js';
import '../../chunks/bundle-C6g3HNED.js';
import '../../chunks/bundle-44j0QAmj.js';
import '../../chunks/bundle-CPQL3IZE.js';
import '../../chunks/bundle-CHW7NXXK.js';
import '../../chunks/bundle--h0f5LUC.js';
import '../../chunks/bundle-u2dy86rx.js';
import '../../chunks/bundle-CxpAk_cb.js';
import '../../chunks/bundle-idC_wVZi.js';
import '../../chunks/bundle-Cj_4CfJM.js';
import 'react-dom';
import '../../chunks/bundle-2OseAMr7.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-BlgLvEI8.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-ZBp236Ey.js';
import '../../chunks/bundle-BjDPDV1u.js';
import '../../chunks/bundle-EMEHizdG.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-Bzoj1u3h.js';
import '../../chunks/bundle-RVsnVYbw.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-B4W1Qw_4.js';
import '../../chunks/bundle-BSUtC3cw.js';
import '../../chunks/bundle-CnQtgeX8.js';
import '../../chunks/bundle-DvCKSiBl.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-B7LMd75S.js';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';

var FileViewer = function (props) {
    var _a = useGroupChannel(), onBeforeDownloadFileMessage = _a.state.onBeforeDownloadFileMessage, deleteMessage = _a.actions.deleteMessage;
    var logger = useSendbird().state.config.logger;
    return (React__default.createElement(FileViewerView, __assign({}, props, { deleteMessage: deleteMessage, onDownloadClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
            var allowDownload, err_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!onBeforeDownloadFileMessage)
                            return [2 /*return*/];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, onBeforeDownloadFileMessage({ message: props.message })];
                    case 2:
                        allowDownload = _c.sent();
                        if (!allowDownload) {
                            e.preventDefault();
                            (_a = logger.info) === null || _a === void 0 ? void 0 : _a.call(logger, 'FileViewer: Not allowed to download.');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _c.sent();
                        (_b = logger.error) === null || _b === void 0 ? void 0 : _b.call(logger, 'FileViewer: Error occurred while determining download continuation:', err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); } })));
};

export { FileViewer, FileViewer as default };
//# sourceMappingURL=FileViewer.js.map
